
export enum PersonalPickupStepState
{
    NotPlannedYet = "NotPlannedYet",
    PrePlanned = "PrePlanned",
    Planned = "Planned",
    AfterMeeting = "AfterMeeting",
    Canceled = "Canceled",
    CanceledDespitePlanned = "CanceledDespitePlanned",
    MeetingOk = "MeetingOk",
    MeetingFailed = "MeetingFailed",
}
